import { JobsClient } from './jobs-client';
import { RemindersClient } from './reminders-client';
import { ServicesClient } from './services-client';
import { CronApiConfig } from './types';

export class CronApiSDK {
  public readonly jobs: JobsClient;
  public readonly reminders: RemindersClient;
  public readonly services: ServicesClient;

  constructor(config: CronApiConfig) {
    this.jobs = new JobsClient(config);
    this.reminders = new RemindersClient(config);
    this.services = new ServicesClient(config);
  }

  /**
   * Test connection to the API
   */
  public async ping(): Promise<{ message: string }> {
    return this.jobs.ping();
  }

  /**
   * Create SDK instance with default configuration
   */
  public static create(baseURL: string, auth?: { username: string; password: string }): CronApiSDK {
    return new CronApiSDK({
      baseURL,
      auth,
    });
  }

  /**
   * Create SDK instance for development
   */
  public static createForDev(auth?: { username: string; password: string }): CronApiSDK {
    return new CronApiSDK({
      baseURL: 'http://localhost:8080',
      auth,
    });
  }
}
